import { Component, inject, Input, OnInit, output } from '@angular/core';
import { Handelsgeschaeft, HandelsgeschaeftHistorie, ReportService } from 'lion-api';
import { SimpleMessageService, TrackingIdService } from '@shared/data';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-business-history-dialog',
  standalone: false,
  templateUrl: './business-history-dialog.component.html',
  styleUrl: './business-history-dialog.component.scss'
})
export class BusinessHistoryDialogComponent implements OnInit {
  @Input() geschaeft?: Handelsgeschaeft;
  @Input() dialogVisible = false;
  businessHistoryVisibleChange = output<boolean>();
  currentDate?: Date;
  geschaeftshistorie?: HandelsgeschaeftHistorie[];
  tradeIdWithoutVersion = '';
  private readonly MESSAGE_KEY = 'business-history';
  private readonly simpleMessageService = inject(SimpleMessageService);
  protected readonly messageState = this.simpleMessageService.getMessageState(this.MESSAGE_KEY);
  protected translateService = inject(TranslateService);
  protected trackingService = inject(TrackingIdService);
  protected reportService = inject(ReportService);

  ngOnInit() {
    this.simpleMessageService.clearInlineMessage(this.MESSAGE_KEY);
    this.currentDate = new Date();
    if (this.geschaeft?.murexId) {
      if (this.geschaeft?.murexId.includes('-')) {
        this.tradeIdWithoutVersion = this.geschaeft?.murexId?.substring(0, this.geschaeft?.murexId?.indexOf('-'));
      } else {
        this.tradeIdWithoutVersion = this.geschaeft.murexId;
      }

      if (this.geschaeft.murexIdVorgaenger) {
        this.reportService.reportShowHistoryGet(this.geschaeft?.murexId, this.trackingService.generateTrackingId()).subscribe({
          next: (value) => {
            if (value.errors && value.errors.length > 0) {
              const msg = value.errors[0].message || this.translateService.instant('shared.error.frontend.details');
              this.simpleMessageService.sendInlineErrorMessage(this.MESSAGE_KEY, msg);
              return;
            }
            this.geschaeftshistorie = value.geschaeftshistorie;
          },
          error: (err) => {
            console.error('Fehler beim Laden der Geschäftshistorie:', err);
            this.simpleMessageService.sendInlineErrorMessage(this.MESSAGE_KEY, this.translateService.instant('shared.error.frontend.details'));
          }
        });
      }
    }
  }

  onDialogHide() {
    this.simpleMessageService.clearInlineMessage(this.MESSAGE_KEY);
    this.businessHistoryVisibleChange.emit(false);
  }

  getTradeIdVersionAsInt(tradeId: string) {
    let tradeVersion = 1;
    if (tradeId && tradeId.includes('-')) {
      tradeVersion = Number(tradeId.substring(tradeId.indexOf('-') + 1));
    }
    return tradeVersion;
  }
}
